import React, { useRef, useState } from 'react';
import Filter from '@/pages/dashboard/components/NewFilter';
import { setBtnPointLog } from '@/pages/dashboard/utils/utils';
import { commonDateDefault } from '../../utils/dateUtils';
import { FORM_MAP } from '@/pages/dashboard/pages/overview/_config/constant';

const firstWordUpper = (str: string) => {
  if (!str) return str;
  const firstLetter = str.charAt(0);
  const firstLetterCap = firstLetter.toUpperCase();
  const remainingLetters = str.slice(1);
  return firstLetterCap + remainingLetters === 'Date' ? 'Day' : firstLetterCap + remainingLetters;
};

/**
 *
 * @param props
 * @param props:filterConfirm 筛选器确认函数
 * @param props:filterReset 筛选器重置函数
 * @param props:setFilterLoading 筛选器loading设置，透传到筛选器组件内部，获取到筛选器列表时区等数据之后，设置为false，测试才可进行页面和组件中的接口调用
 * @param props:filterInit 初始化函数，会向外部传递初始化后的筛选器值
 * @returns
 */

const FILTER_PATH = 'monetization/revenue';
// daily筛选器继承逻辑
const RevenueFilterNew = (props: any) => {
  const {
    filterConfirm,
    filterReset,
    buttonLogConfig,
    setFilterLoading,
    filterInit,
    openSticky = false,
    path = FILTER_PATH,
    children,
    isHaveFilterSave,
    timeZone = 0,
    config
  } = props;
  const {
    granularity,
    dateOffSet,
    enableDateOffset = false,
  } = config || {};
  // 筛选器路径

  const filterValueRef = useRef<any>(null); // 筛选器值，此处不用state，更新formValue同样会触发组件更新

  // 设置inputList
  const [inputList] = useState([{
    ...commonDateDefault(timeZone, undefined, granularity, dateOffSet),
    showSelectType: (granularity ? granularity?.length > 1 : true),
  }]);

  const handleConfirm = (value: any) => {
    filterValueRef.current = value;
    filterConfirm?.({
      // filterValue: {
      ...value,
      rangeTime: [value?.rangeTime?.value?.[0]?.format('YYYY-MM-DD'), value?.rangeTime?.value?.[1]?.format('YYYY-MM-DD')],
      // },
      timeType: firstWordUpper(value?.rangeTime?.type),
      pagePath: path,
      ...(enableDateOffset && { [FORM_MAP.RANGE_TIME_DIFF]: false }),
    });
    // 打点，沟通后打点操作放在业务代码的confirm和reset中，不封装在新版本筛选器中
    setBtnPointLog(buttonLogConfig, {
      ...value,
      rangeTime: [value?.rangeTime?.value?.[0]?.format('YYYY-MM-DD'), value?.rangeTime?.value?.[1]?.format('YYYY-MM-DD')],
      timeType: firstWordUpper(value?.rangeTime?.type)
    });
  };

  const handleReset = (value: any) => {
    filterValueRef.current = value;
    filterReset?.({
      // filterValue: {
      ...value,
      rangeTime: [value?.rangeTime?.value?.[0]?.format('YYYY-MM-DD'), value?.rangeTime?.value?.[1]?.format('YYYY-MM-DD')],
      // },
      timeType: firstWordUpper(value?.rangeTime?.type),
      pagePath: path,
      ...(enableDateOffset && { [FORM_MAP.RANGE_TIME_DIFF]: true }),
    });
    // 打点，沟通后打点操作放在业务代码的confirm和reset中，不封装在新版本筛选器中
    setBtnPointLog(buttonLogConfig, {
      ...value,
      rangeTime: [value?.rangeTime?.value?.[0]?.format('YYYY-MM-DD'), value?.rangeTime?.value?.[1]?.format('YYYY-MM-DD')],
      timeType: firstWordUpper(value?.rangeTime?.type)
    }, true);
  };

  const handleInit = (value: any, _inputList, isHaveExtendFIlter) => {
    filterValueRef.current = value;
    filterInit?.({
      // filterValue: {
      ...value,
      rangeTime: [value?.rangeTime?.value?.[0]?.format('YYYY-MM-DD'), value?.rangeTime?.value?.[1]?.format('YYYY-MM-DD')],
      // },
      timeType: firstWordUpper(value?.rangeTime?.type),
      pagePath: path,
      ...(enableDateOffset && { [FORM_MAP.RANGE_TIME_DIFF]: !isHaveExtendFIlter }),
    });
    setFilterLoading(false);
  };

  // const handleChange = (key: string, value: any) => {
  //   if (key === 'rangeTime') {
  //     filterValueRef.current = {
  //       ...filterValueRef.current,
  //       [key]: {
  //         type: value.type,
  //         value: value.value,
  //       },
  //     };
  //   }
  // };

  return (
    <Filter
      openSticky={openSticky}
      path={path}
      value={filterValueRef.current}
      latestDateType='revenue'
      inputList={inputList}
      onInit={handleInit}
      onConfirm={handleConfirm}
      onReset={handleReset}
      isHaveFilterSave={isHaveFilterSave}
      // onChange={handleChange}
    >
      {children}
    </Filter>
  );
};

export default RevenueFilterNew;
